import classNames from 'classnames';
import { Children, cloneElement, type FC, type HTMLAttributes, type ReactElement } from 'react';

import { TCell, type TCellProps } from '../tcell';
import styles from './trow.module.scss';

type TCellElement = ReactElement<TCellProps, typeof TCell>;

export type TRowProps = HTMLAttributes<HTMLTableRowElement> & {
  children: TCellElement | TCellElement[];
  hasHover?: boolean;
  hoverColor?: string;
  backgroundColor?: string;
  isUnsetBorder?: boolean;
  className?: string;
};

export const TRow: FC<TRowProps> = ({
  children,
  className,
  hasHover,
  hoverColor,
  backgroundColor,
  isUnsetBorder,
  onClick,
  ...props
}) => {
  const hoverStyle = hoverColor
    ? ({ '--hover-color': hoverColor } as React.CSSProperties)
    : undefined;

  const backgroundStyle = backgroundColor
    ? ({ '--background-color': backgroundColor } as React.CSSProperties)
    : undefined;

  return (
    <tr
      className={classNames(styles.root, className, {
        [styles.hasOnClick]: !!onClick,
        [styles.hover]: hasHover,
        [styles.unsetBorder]: isUnsetBorder,
      })}
      style={{ ...hoverStyle, ...backgroundStyle }}
      onClick={onClick}
      {...props}
    >
      {Children.map(children, (child, index) => cloneElement(child, { index }))}
    </tr>
  );
};
